/**
 * ClientTypeIcon — квадратный чип с иконкой типа клиента: здание для
 * клиники (нейтральный фон), человек для соло (акцентный фон). Один
 * источник вместо повторения в таблице и мобильной карточке.
 */

import {Building2, User} from 'lucide-react';

import type {ClinicType} from '@services/clients';
import {cn} from '@lib/utils';

type ClientTypeIconProps = {
  type: ClinicType;
  /** Сторона чипа, px (иконка = ~половина). */
  size?: number;
  className?: string;
};

export const ClientTypeIcon = ({type, size = 36, className}: ClientTypeIconProps) => {
  const isClinic = type === 'clinic';
  const Icon = isClinic ? Building2 : User;
  return (
    <span
      className={cn(
        'grid shrink-0 place-items-center',
        isClinic ? 'bg-skr-icon-bg text-muted-foreground' : 'bg-accent text-primary',
        className,
      )}
      style={{width: size, height: size, borderRadius: Math.round(size * 0.26)}}
    >
      <Icon
        style={{width: Math.round(size * 0.5), height: Math.round(size * 0.5)}}
        strokeWidth={1.7}
      />
    </span>
  );
};
